import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Check, AlertTriangle } from 'lucide-react';
import { Countdown } from './Countdown';
export function PricingSection() {
  return <section id="pricing" className="py-14 bg-petroleum relative overflow-hidden" data-id="element-435">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-electric to-transparent opacity-50" data-id="element-436"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-437">
        {/* Scarcity Header */}
        <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-438">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 border border-red-500/20 px-4 py-2 rounded-full text-sm font-bold mb-5" data-id="element-439">
            <AlertTriangle className="w-4 h-4" data-id="element-440" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>

          <div className="mb-5" data-id="element-441">
            <Countdown data-id="element-442" />
          </div>

          <p className="text-textsecondary mb-2" data-id="element-443">
            ⚠️ Después sube $10.000 ARS. No vuelve.
          </p>
          <p className="text-energy font-medium flex items-center justify-center gap-2" data-id="element-444">
            72% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-445">
          {/* Outer glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-blue-300 to-electric rounded-3xl blur-xl opacity-40 animate-pulse" data-id="element-446"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/30" data-id="element-447">
            {/* Grid pattern background */}
            <div className="absolute inset-0 opacity-[0.10] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(56,189,248,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(56,189,248,0.7) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-448"></div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-449"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-450"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-451"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-452"></div>

            <div className="relative z-10" data-id="element-453">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="inline-flex items-center gap-2 bg-electric text-graphite border border-electric px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-electric/40" data-id="element-454">
                <Zap className="w-3.5 h-3.5 fill-graphite" data-id="element-455" />
                Acceso Instantáneo
              </motion.div>
              <h2 className="text-3xl md:text-5xl font-extrabold flex items-center justify-center gap-3 flex-wrap" data-id="element-456">
                <Zap className="w-7 h-7 md:w-9 md:h-9 text-gold fill-gold drop-shadow-[0_0_8px_rgba(255,200,0,0.6)]" data-id="element-457" />
                <span className="text-white" data-id="element-458">ELEGÍ TU</span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-blue-300 to-electric drop-shadow-[0_0_12px_rgba(56,189,248,0.4)]" data-id="element-459">
                  KIT
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70" data-id="element-460"></div>
            </div>
          </div>
        </motion.div>

        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 items-center" data-id="element-461">
          {/* Basic Plan */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-graphite border border-white/10 rounded-3xl p-8 hover:border-electric/30 transition-all relative" data-id="element-462">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-petroleum border border-electric/40 text-electric font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wider flex items-center gap-1.5" data-id="element-463">
              <Zap className="w-3 h-3 fill-electric" data-id="element-464" /> Plan Esencial
            </div>

            <div className="mb-6 pt-2" data-id="element-465">
              <h3 className="text-2xl font-bold leading-tight mb-1.5 flex items-start gap-2" data-id="element-466">
                <Zap className="w-5 h-5 text-electric fill-electric mt-1 flex-shrink-0" data-id="element-467" />
                <span data-id="element-468">KIT ELECTRICIDAD EN CASA</span>
              </h3>
              <p className="text-sm text-textsecondary" data-id="element-469">6 Tomos + 6 Bonos</p>
            </div>

            <div className="bg-petroleum rounded-xl p-4 mb-8" data-id="element-470">
              <p className="text-sm text-textsecondary mb-1" data-id="element-471">Ideal para:</p>
              <p className="font-medium" data-id="element-472">Autonomía total en tu hogar</p>
            </div>

            <div className="mb-8" data-id="element-473">
              <span className="text-textsecondary line-through text-xl" data-id="element-474">
                $59.000
              </span>
              <div className="flex items-baseline gap-2" data-id="element-475">
                <span className="text-4xl font-extrabold text-white" data-id="element-476">
                  $19.990
                </span>
                <span className="text-textsecondary font-medium" data-id="element-477">ARS</span>
              </div>
            </div>

            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBtdqfmZw6mycXp8XOqb90/es-ar?_r=AQABgnNpXVO1rI1txCBQNxGb_YcTrUPiJJDRD8WaZPPvwao&cart_link_id=NRLX8ejE&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-petroleum to-petroleum/80 hover:from-electric/20 hover:to-electric/10 border border-electric/50 hover:border-electric text-white font-bold py-3.5 rounded-xl transition-all duration-300 flex items-center justify-between gap-3 pl-4 pr-2 shadow-md hover:shadow-lg hover:shadow-electric/20" data-id="element-478">
              <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-electric/15 border border-electric/30 flex items-center justify-center group-hover:bg-electric/25 transition-colors" data-id="element-479">
                <Zap className="w-4 h-4 text-electric fill-electric" data-id="element-480" />
              </span>
              <span className="flex-1 text-center text-sm md:text-base tracking-wide" data-id="element-481">
                QUIERO MI KIT
              </span>
              <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-electric/15 text-electric flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-482">
                <Check className="w-4 h-4" strokeWidth={3} data-id="element-483" />
              </span>
            </a>
          </motion.div>

          {/* Pro Plan */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-[#1a2642] to-petroleum border-2 border-electric rounded-3xl p-8 relative transform md:-translate-y-4 glow-electric" data-id="element-484">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-graphite font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1" data-id="element-485">
              <Zap className="w-4 h-4 fill-graphite" data-id="element-486" /> MÁS POPULAR
            </div>

            <h3 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-487">
              KIT + EMPRENDEDOR
            </h3>
            <p className="text-textsecondary mb-6" data-id="element-488">
              6 Tomos + 6 Bonos + Manual del Electricista Emprendedor
            </p>

            <div className="bg-graphite/50 rounded-xl p-4 mb-8 border border-gold/20" data-id="element-489">
              <p className="text-sm text-gold mb-1" data-id="element-490">Ideal para:</p>
              <p className="font-medium" data-id="element-491">
                Los que quieren monetizar el conocimiento
              </p>
            </div>

            <div className="mb-8" data-id="element-492">
              <span className="text-textsecondary line-through text-xl" data-id="element-493">
                $84.000
              </span>
              <div className="flex items-baseline gap-2" data-id="element-494">
                <span className="text-5xl font-extrabold text-white" data-id="element-495">
                  $27.990
                </span>
                <span className="text-textsecondary font-medium" data-id="element-496">ARS</span>
              </div>
            </div>

            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBte3hZ4VnB2gzUPhbZCeA/es-ar?_r=AQABnYG6CXEPZmPUzlBa5y9-PjHk-TUFy23-FX4xkKx4UqY&cart_link_id=5Kg6Mib6&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-yellow-300 via-gold to-yellow-400 hover:from-yellow-200 hover:via-yellow-300 hover:to-gold text-graphite font-extrabold rounded-2xl transition-all duration-300 transform hover:-translate-y-1 shadow-[0_0_25px_rgba(255,200,0,0.5)] hover:shadow-[0_0_40px_rgba(255,200,0,0.85)] flex items-center justify-between gap-3 pl-3 pr-3 py-3 uppercase tracking-wide overflow-hidden border-2 border-yellow-200" data-id="element-497">
              {/* Animated sheen */}
              <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-12 pointer-events-none" data-id="element-498"></span>

              {/* Left icon badge */}
              <span className="relative z-10 flex-shrink-0 w-10 h-10 rounded-xl bg-graphite/15 backdrop-blur-sm flex items-center justify-center" data-id="element-499">
                <Zap className="w-5 h-5 fill-graphite text-graphite" data-id="element-500" />
              </span>

              {/* Centered label */}
              <span className="relative z-10 flex-1 text-center text-sm md:text-base leading-tight" data-id="element-501">
                Quiero el Kit + Emprendedor
              </span>

              {/* Right arrow badge */}
              <span className="relative z-10 flex-shrink-0 w-10 h-10 rounded-xl bg-graphite text-gold flex items-center justify-center transition-transform duration-300 group-hover:translate-x-0.5 shadow-md" data-id="element-502">
                <Check className="w-5 h-5" strokeWidth={3} data-id="element-503" />
              </span>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}